// extracted by mini-css-extract-plugin
export var $animation_name = "FAQ-module--$animation_name--735ba";
export var accordion = "FAQ-module--accordion--692ff";
export var accordion__container = "FAQ-module--accordion__container--4fa09";
export var accordion__title = "FAQ-module--accordion__title--8c749";
export var accordion__triggerBlurb = "FAQ-module--accordion__triggerBlurb--bfa28";
export var accordion__triggerClose = "FAQ-module--accordion__triggerClose--d6f31";
export var accordion__triggerPlus = "FAQ-module--accordion__triggerPlus--13daf";
export var accordion__wrapper = "FAQ-module--accordion__wrapper--2580b";